import { render, staticRenderFns } from "./ClientOpportunitiesTabComponent.vue?vue&type=template&id=9f9ae738&scoped=true&"
import script from "./ClientOpportunitiesTabComponent.vue?vue&type=script&lang=ts&"
export * from "./ClientOpportunitiesTabComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ClientOpportunitiesTabComponent.vue?vue&type=style&index=0&id=9f9ae738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9ae738",
  null
  
)

export default component.exports